import { LEAD_SOURCE, LEAD_INTEREST, LEAD_STATUS, PRIORITY } from "./enums";

export const EMPTY_LEAD_FORM = {
  title: "",
  company_id: null,
  contact_id: null,
  contact_name: "",
  contact_email: "",
  contact_phone: "",
  company_name: "",
  description: "",
  source: LEAD_SOURCE.MANUAL,
  interest: LEAD_INTEREST.OTHER,
  status: LEAD_STATUS.NEW,
  priority: PRIORITY.MEDIUM,
};

export function buildInitialLeadForm({ initialCompany, initialContact }) {
  const next = { ...EMPTY_LEAD_FORM };

  if (initialCompany?.id) {
    next.company_id = initialCompany.id;
    if (!next.company_name.trim()) next.company_name = initialCompany.name || "";
  }

  if (initialContact?.id) {
    next.contact_id = initialContact.id;
    if (!next.contact_name.trim()) {
      next.contact_name = `${initialContact.first_name || ""} ${initialContact.last_name || ""}`.trim();
    }
    if (!next.contact_email.trim()) next.contact_email = initialContact.email || "";
    if (!next.contact_phone.trim()) next.contact_phone = initialContact.phone || "";
    if (initialContact.company_id) next.company_id = initialContact.company_id;
  }

  return next;
}

export function applyCompanySelection({ form, company }) {
  const next = { ...form };
  next.company_id = company?.id || null;
  if (company?.name && !next.company_name.trim()) next.company_name = company.name;
  return next;
}

export function applyContactSelection({ form, contact, companyForContact }) {
  const next = { ...form };
  next.contact_id = contact?.id || null;

  if (contact) {
    if (!next.contact_name.trim()) next.contact_name = `${contact.first_name || ""} ${contact.last_name || ""}`.trim();
    if (!next.contact_email.trim()) next.contact_email = contact.email || "";
    if (!next.contact_phone.trim()) next.contact_phone = contact.phone || "";
    if (contact.company_id) next.company_id = contact.company_id;
  }

  if (companyForContact?.id) {
    next.company_id = companyForContact.id;
    if (companyForContact.name && !next.company_name.trim()) next.company_name = companyForContact.name;
  }

  return next;
}

